/**
 * ============================================================================
 * EXPERIMENT: Travel Rhythm Display (ab_travel_rhythm)
 *
 * Backend-driven AB test — variant decided server-side via API
 * `meta.experiment.travelRhythm`. No Amplitude experiment, no entry in
 * `feature-flags.json`: the variant is implicit — this item renders only
 * when the API returns a rhythm value.
 *
 * PR: #TODO_AFTER_PR_CREATION_ab_travel_rhythm
 * Expected end date: 2026-07-22 (remove all AB_* files and BEGIN/END markers by then).
 *
 * Temporary code — will be REMOVED when the experiment concludes.
 * Find all experiment code: grep -rn "ab_travel_rhythm" src/
 * ============================================================================
 */
import { Typography } from '@evaneos/b2b-ui';
import DirectionsWalkingIcon from '@evaneos/b2b-ui/icons/DirectionsWalkOutlined';
import { useIntl } from 'react-intl';

import { DefinitionList } from '../../../design-system/DefinitionList/DefinitionList';
import { TravelRhythmValue } from '../../../resources/dossier/types';

type Props = {
    value: TravelRhythmValue | undefined;
    isFirstColumnNarrow: boolean;
};

export function AB_TravelRhythmItem({ value, isFirstColumnNarrow }: Readonly<Props>) {
    const { formatMessage } = useIntl();

    if (!value) return null;

    return (
        <DefinitionList.Item>
            <DefinitionList.Label
                id="travel-rhythm"
                icon={<DirectionsWalkingIcon fontSize="small" aria-hidden="true" />}
                iconOnly={isFirstColumnNarrow}
            >
                {formatMessage({ id: 'dossier.travelRhythm.fieldLabel' })}
            </DefinitionList.Label>
            <DefinitionList.StaticValue>
                <Typography variant="body2" data-spec-id="travel-rhythm-value">
                    {formatMessage({ id: `dossier.travelRhythm.value.${value}` })}
                </Typography>
            </DefinitionList.StaticValue>
        </DefinitionList.Item>
    );
}
